import { CategoryMasterDataFormValues } from '../../ImpactsOnStakeholdersFormProvider/types';

export const sortByOthersAtBottom = (
  list: CategoryMasterDataFormValues[]
): CategoryMasterDataFormValues[] =>
  [...list].sort((prev, current) =>
    prev.nameEn === 'Others' ? 1 : current.nameEn === 'Others' ? -1 : 0
  );
